// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

// Capture beforeinstallprompt so we can show it later (e.g., after signup)
window.deferredA2HS = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault(); // Prevent the browser from immediately showing the prompt
  window.deferredA2HS = e; // Save it for later
  // Optionally: show a small UI hint like "Install Nukkad" (you can implement)
});

// Register the service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      await navigator.serviceWorker.register("/service-worker.js");
      console.log("SW registered: /service-worker.js");
    } catch (err) {
      console.warn("SW register failed:", err);
    }
  });
}
